import React from 'react';
import { STAFF_GROUP_COLORS } from 'constants/calendar';
import { verifyPinCode } from 'widgets/ModalVerifyAdminPin';
import ModalStaffGroups, { useModalStaffGroupsRef } from './ModalStaffGroups';

const ButtonStaffGroups = () => {
  const modal = useModalStaffGroupsRef();

  // Admin-gated: grouping is a shop-wide display setting, so the PIN guards opening the modal.
  // Uses the app-level verify modal mounted once in App.tsx — never mount a second instance.
  // forceVerifyAdmin, not checkAdmin: the latter waves the prompt through whenever the shop has
  // verifyPinChangeAppointment off, which would leave this setting unguarded.
  const onOpen = () => {
    verifyPinCode.current?.forceVerifyAdmin(() => {
      modal.current?.open();
    }, {
      title: 'STAFF GROUPS',
      placeholder: 'Enter Admin Pin Code',
    });
  };

  return (
    <>
      <button onClick={onOpen}><IconStaffGroups /></button>
      <ModalStaffGroups ref={modal} />
    </>
  );
};

export default ButtonStaffGroups;

const IconStaffGroups = () => (
  <div style={{ width: '48px', height: '48px', background: '#fff', border: '1px solid #7B7B7B', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 100 }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="1" y="1" width="9" height="9" rx="2" fill={STAFF_GROUP_COLORS[0]} />
      <rect x="14" y="1" width="9" height="9" rx="2" fill={STAFF_GROUP_COLORS[1]} />
      <rect x="1" y="14" width="9" height="9" rx="2" fill={STAFF_GROUP_COLORS[2]} />
      <rect x="14" y="14" width="9" height="9" rx="2" fill="#D9D9D9" />
    </svg>
  </div>
);
